import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { OperadoresApi } from '@/services/api-routes'
import { emptyPage } from '@/types/api'
import type { ListarOperadoresQuery, OperadorResumo } from '@/types/operador'
import { operadoresKeys } from '@/http/queryKeys'
import { defaultOptions } from '@/http/default-query-options'

export const useOperadoresQuery = (query: ListarOperadoresQuery, enabled = true) =>
  useQuery({
    queryKey: operadoresKeys.list(query),
    queryFn: async ({ signal }) =>
      (await OperadoresApi.listar(query, signal)) ?? emptyPage<OperadorResumo>(),
    placeholderData: keepPreviousData,
    enabled,
    ...defaultOptions,
  })
